import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { getAssets } from '../../services/assetService';
import { apiParamsState, isAllWorkspacesSelect } from '../../storage/app';
import { assetsState } from '../../storage/assets';

function AssetsProvider() {
  const apiParams = useRecoilValue(apiParamsState);
  const setAssets = useSetRecoilState(assetsState);
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);

  useEffect(() => {
    if (!apiParams) return;

    const loadAssets = async () => {
      const { assets, error } = await getAssets(
        apiParams.clientId, isAllWorkspacesSelected ? undefined : apiParams.subClientId
      );
      if (!error && assets) {
        setAssets(assets);
      } else {
        setAssets(undefined);
      }
    };
    loadAssets();
  }, [apiParams, setAssets]);

  return null;
}

export default AssetsProvider;
